// Module
var code = "<div class=\"form-control\" ng-jsoneditor ng-model=\"data[component.key]\" options=\"component.options\" prefer-text=\"component.preferText\" ng-attr-name=\"{{ componentId || component.key }}\" ng-change=\"changeValue()\"></div> ";
// Exports
export default code;